import React, { useState, useEffect } from "react";
import {
  Collapse,
  Card,
  Tag,
  Button,
  Descriptions,
  Typography,
  Space,
  Modal,
  message,
  Result,
  Spin
} from "antd";
import {
  EnvironmentOutlined,
  DollarOutlined,
  CalendarOutlined,
  SendOutlined,
  CheckCircleOutlined,
  SyncOutlined,
  InfoCircleOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
// import { FcInTransit } from "react-icons/fc";
// import { BsFillClipboard2PulseFill } from "react-icons/bs";
// import { FaMapMarkerAlt } from "react-icons/fa";
// import { makeShippment, userMemberShip } from "./../../services";

const { Panel } = Collapse;
const { Text, Title } = Typography;
const { confirm } = Modal;

export default function MultipleShippment({isSelecetd, data = [] }) {
  const [loadingId, setLoadingId] = useState(null);

  const [loading, setLoading] = useState(false);
  const [shipmentUserID, setShipmentuserID] = useState(null);
  const [shippmentData, setShippmentData] = useState(data || []);

//   const fetchShippments = async () => {
//     const {user_id} = data[0];
// setLoading(true);
//     const responseData = await userMemberShip(user_id);
//     if (responseData.code === 200) {
//       const subData = responseData.data.shippments;
//       setShippmentData(subData);
//     }
//      setLoading(false);
//   };

  const handleCreateShipment = (shipment) => {
    // confirm({
    //   title: "Are you sure you want to create this shipment?",
    //   okText: "Yes, Create",
    //   cancelText: "Cancel",
    //   okButtonProps: { className: "btn-glow" },
    //   onOk: async () => {
    //     try {
    //       setLoadingId(shipment.id);
    //       message.loading({ content: "Creating shipment...", key: "create" });
    //       setLoading(true);
    //       const thisData = await makeShippment(shipment);
    //       if (thisData.status === "success") {
    //         setLoading(false);
    //         await fetchShippments(shipment.user_id);
            
    //         message.success({
    //           content: "Shipment created successfully!",
    //           key: "create",
    //           duration: 2,
    //         });
    //       } else {
    //         message.error({
    //           content: "Failed to create shipment. Please try again.",
    //           key: "create",
    //         });
    //       }
    //     } catch (error) {
    //       console.error(error);
    //       message.error({
    //         content: "Failed to create shipment. Please try again.",
    //         key: "create",
    //       });
    //     } finally {
    //       setLoadingId(null);
    //     }
    //   },
    //   onCancel() {
    //     message.info("Shipment creation cancelled.");
    //   },
    // });
  };

  // 🔁 Map for EasyPost Shipment Tracker Status
  const statusMap = {
    pre_transit: { color: "gold", label: "Label Created 🏷️" },
    in_transit: { color: "blue", label: "In Transit 🚚" },
    out_for_delivery: { color: "purple", label: "Out for Delivery 📦" },
    delivered: { color: "green", label: "Delivered ✅" },
    pending: { color: "orange", label: "Pending ⏳" },
    pending_shipment: { color: "orange", label: "Pending ⏳"}
  };

  const getStatusTag = (status = "pending") => {
    const current = statusMap[status] || statusMap["pending"];
    return (
      <Tag color={current.color} style={{ fontSize: 15, padding: "2px 6px" }}>
        {current.label}
      </Tag>
    );
  };

 console.log("Shipment Data:", isSelecetd);
  return (
    <Card
      style={{
        borderRadius: 16,
        background: "rgba(255, 255, 255, 0.04)",
        boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
      }}

      className="multiShipment"
      title={<Title level={4}>📦 Shipments</Title>}
    //   extra={<Button size="large" shape="round"  icon={<SyncOutlined />} />}
    >
      <Spin size="large" spinning={loading} >
      {shippmentData.length > 0 ? (
        <Collapse accordion bordered={false} style={{ background: "transparent" }}>
          {shippmentData.map((shipment, index) => (
            (shipment.shipment_status !=="direct_purchase"  &&  isSelecetd.sub_schedule_id == shipment['order_id']) &&  (
            <Panel
              key={shipment.id}
              header={
                <Space direction="horizontal" size={10} align="center">
                  <Tag color="blue"># {index + 1}</Tag>
                  <Tag color="blue">Qty {shipment.quantity}</Tag>
                  <Text style={{ color: "#000", fontWeight: 500 }}>
                    ID: {shipment.id}
                  </Text>
                  {getStatusTag(shipment.shipment_status)}
                </Space>
              }
              style={{
                border: "1px solid rgba(0,0,0,0.1)",
                borderRadius: 12,
                background: "#fff",
                marginBottom: 10,
              }}
            >
              <Descriptions bordered size="small" column={1}>
                <Descriptions.Item label="Shipment ID">{shipment.id}</Descriptions.Item>
                <Descriptions.Item label="Customer ID">
                  {shipment.customer_id}
                </Descriptions.Item>
                <Descriptions.Item label="Product">
                  Aletheia Sensor v1.0
                </Descriptions.Item>
                <Descriptions.Item label="Quantity">
                  {shipment.quantity} Sensors
                </Descriptions.Item>
                <Descriptions.Item label="Shipment Cost">
                  <DollarOutlined /> ${(shipment.shipment_cost / 100).toFixed(2)}
                </Descriptions.Item>
                <Descriptions.Item label="Billing Name">
                  <EnvironmentOutlined /> {shipment.address?.billing?.name}
                </Descriptions.Item>
                <Descriptions.Item label="Billing Address">
                  {shipment.address?.billing?.address?.line1},{" "}
                  {shipment.address?.billing?.address?.city},{" "}
                  {shipment.address?.billing?.address?.state}{" "}
                  {shipment.address?.billing?.address?.postal_code}
                </Descriptions.Item>
                <Descriptions.Item label="Shipping Address">
                  {shipment.address?.shipping?.address?.line1},{" "}
                  {shipment.address?.shipping?.address?.city},{" "}
                  {shipment.address?.shipping?.address?.state}{" "}
                  {shipment.address?.shipping?.address?.postal_code}
                </Descriptions.Item>
                <Descriptions.Item label="Created At">
                  <CalendarOutlined /> {new Date(shipment.created_at).toLocaleString()}
                </Descriptions.Item>
              </Descriptions>

              <Space direction="horizontal" style={{ marginTop: 15 }}>
                {shipment.shipment_status === "pending" ? (
                 <Tag
                    icon={<InfoCircleOutlined />}
                    color="orange"
                    style={{ fontSize: "15px", padding: "2px 5px" }}
                  >
                    Shipment Pending
                  </Tag>
                ) : (
                  <Tag
                    icon={<CheckCircleOutlined />}
                    color="success"
                    style={{ fontSize: "15px", padding: "2px 5px" }}
                  >
                    Shipment Created
                  </Tag>
                )}

                {shipment.tracking_number ? (
                  <>
                    <Tag  icon={<EnvironmentOutlined/>} color="green" style={{ fontSize: "15px", padding: "2px 5px" }}>
                      <a
                        href="#"
                        onClick={() => {
                          window.open(
                            shipment.shipment_response.tracker.public_url,
                            "TrackingWindow",
                            "width=600,height=800"
                          );
                        }}
                      >
                       Tracking <ArrowRightOutlined/>  {shipment.tracking_number}
                      </a>
                    </Tag>
                    {/* <Tag color="purple" style={{ fontSize: "15px", padding: "2px 5px" }}>
                      <a
                        href="#"
                        onClick={() => {
                          window.open(
                            shipment.shipment_label_url,
                            "LabelWindow",
                            "width=600,height=800"
                          );
                        }}
                      >
                         View Label
                      </a>
                    </Tag> */}
                  </>
                ) : (
                  <Tag color="gold" style={{ fontSize: "15px", padding: "2px 5px" }}>
                    No Tracking Yet
                  </Tag>
                )}
              </Space>
            </Panel>
          )))}
        </Collapse>
      ) : (
        <Result
          status="403"
          title="No Shipments Found"
          subTitle="There are no shipments available for this user."
        />
      )}
       </Spin>
    </Card>
  );
}
